import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import AuthModule from "./modules/authModule";
import OptionsModule from "./modules/OptionsModule";
import formSurveyModule from "./modules/formSurveyModule";
import plantsModule from "./modules/plantsModule";
import dashboardModule from "./modules/dashboardModule";
import communityModule from "./modules/communityModule";
import viewModule from "./modules/viewModule";
import categoriesModule from "./modules/categoriesModule";
import knowledgesModule from "./modules/knowledgesModule";
import createMultiTabState from 'vuex-multi-tab-state';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    AuthModule: AuthModule,
    OptionsModule: OptionsModule,
    formSurveyModule: formSurveyModule,
    plantsModule: plantsModule,
    communityModule: communityModule,
    viewModule: viewModule,
    categoriesModule: categoriesModule,
    knowledgesModule: knowledgesModule,
    dashboardModule: dashboardModule,
  },
  plugins: [
    createPersistedState(),
    createMultiTabState({
      statesPaths: ['AuthModule.userData', 'AuthModule.accessToken','plantsModule.plants_survey', 'plantsModule.plants_bank'],
    }),],
});
